import React, { useState, useEffect } from 'react';
import { insuranceAPI } from '../../../services/api';
import ImageUploader from '../Shared/ImageUploader';
import '../Shared/FormStyles.scss';

const InsuranceManager = () => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    image: '',
    isActive: true,
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchProviders();
  }, []);

  const fetchProviders = async () => {
    try {
      const response = await insuranceAPI.getAllAdmin();
      setProviders(response.data);
    } catch (err) {
      setError('Failed to fetch insurance providers');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      if (editing) {
        await insuranceAPI.update(editing._id, formData);
        setSuccess('Insurance provider updated successfully');
      } else {
        await insuranceAPI.create(formData);
        setSuccess('Insurance provider created successfully');
      }
      resetForm();
      fetchProviders();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save insurance provider');
    }
  };

  const handleEdit = (provider) => {
    setEditing(provider);
    setFormData({
      name: provider.name || '',
      image: provider.image || '',
      isActive: provider.isActive !== undefined ? provider.isActive : true,
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this insurance provider?')) return;
    try {
      await insuranceAPI.delete(id);
      setSuccess('Insurance provider deleted successfully');
      fetchProviders();
    } catch (err) {
      setError('Failed to delete insurance provider');
    }
  };

  const resetForm = () => {
    setEditing(null);
    setFormData({
      name: '',
      image: '',
      isActive: true,
    });
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="insurance-manager">
      <div className="admin-form">
        <h2>{editing ? 'Edit Insurance Provider' : 'Add New Insurance Provider'}</h2>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>
          <ImageUploader
            value={formData.image}
            onChange={(url) => setFormData({ ...formData, image: url })}
            label="Logo"
          />
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.isActive}
                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
              />
              Active
            </label>
          </div>
          <div className="form-actions">
            <button type="submit" className="dashboard-btn btn-primary">
              {editing ? 'Update' : 'Create'}
            </button>
            {editing && (
              <button type="button" className="dashboard-btn btn-secondary" onClick={resetForm}>
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="data-table" style={{ marginTop: '30px' }}>
        <h2 style={{ padding: '20px', margin: 0 }}>All Insurance Providers</h2>
        {providers.length === 0 ? (
          <div className="empty-state">No insurance providers found</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Logo</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {providers.map((provider) => (
                <tr key={provider._id}>
                  <td>{provider.name}</td>
                  <td>
                    {provider.image && (
                      <img src={provider.image} alt={provider.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                    )}
                  </td>
                  <td>{provider.isActive ? 'Active' : 'Inactive'}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => handleEdit(provider)}>
                        Edit
                      </button>
                      <button className="btn-delete" onClick={() => handleDelete(provider._id)}>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default InsuranceManager;
